/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenGoal Platform API
 * Agency-facing API — day-to-day platform usage by agency users.
 * OpenAPI spec version: 1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CancelInvitationResponseDto,
  CreateInvitationDto,
  InvitationsControllerListPendingV1200,
  InvitationsControllerListPendingV1Params,
  PendingInvitationDto
} from '../model';

import { apiRequest } from '../../client.ts';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getInvitationsControllerCreateV1Url = () => {




  return `/v1/invitations`
}

/**
 * @summary Invite a user by email (root user only)
 */
export const invitationsControllerCreateV1 = async (createInvitationDto: CreateInvitationDto, options?: RequestInit): Promise<PendingInvitationDto> => {

  return apiRequest<PendingInvitationDto>(getInvitationsControllerCreateV1Url(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createInvitationDto)
  }
);}





export const getInvitationsControllerCreateV1QueryKey = (createInvitationDto?: CreateInvitationDto,) => {
    return [
    'POST', `/v1/invitations`, createInvitationDto
    ] as const;
    }


export const getInvitationsControllerCreateV1QueryOptions = <TData = Awaited<ReturnType<typeof invitationsControllerCreateV1>>, TError = unknown>(createInvitationDto: CreateInvitationDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof invitationsControllerCreateV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInvitationsControllerCreateV1QueryKey(createInvitationDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof invitationsControllerCreateV1>>> = ({ signal }) => invitationsControllerCreateV1(createInvitationDto, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof invitationsControllerCreateV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type InvitationsControllerCreateV1QueryResult = NonNullable<Awaited<ReturnType<typeof invitationsControllerCreateV1>>>
export type InvitationsControllerCreateV1QueryError = unknown


export function useInvitationsControllerCreateV1<TData = Awaited<ReturnType<typeof invitationsControllerCreateV1>>, TError = unknown>(
 createInvitationDto: CreateInvitationDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof invitationsControllerCreateV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof invitationsControllerCreateV1>>,
          TError,
          Awaited<ReturnType<typeof invitationsControllerCreateV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInvitationsControllerCreateV1<TData = Awaited<ReturnType<typeof invitationsControllerCreateV1>>, TError = unknown>(
 createInvitationDto: CreateInvitationDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof invitationsControllerCreateV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof invitationsControllerCreateV1>>,
          TError,
          Awaited<ReturnType<typeof invitationsControllerCreateV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInvitationsControllerCreateV1<TData = Awaited<ReturnType<typeof invitationsControllerCreateV1>>, TError = unknown>(
 createInvitationDto: CreateInvitationDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof invitationsControllerCreateV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Invite a user by email (root user only)
 */

export function useInvitationsControllerCreateV1<TData = Awaited<ReturnType<typeof invitationsControllerCreateV1>>, TError = unknown>(
 createInvitationDto: CreateInvitationDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof invitationsControllerCreateV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getInvitationsControllerCreateV1QueryOptions(createInvitationDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getInvitationsControllerListPendingV1Url = (params?: InvitationsControllerListPendingV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/invitations?${stringifiedParams}` : `/v1/invitations`
}

/**
 * @summary List pending invitations, paginated/searchable/orderable (root user only)
 */
export const invitationsControllerListPendingV1 = async (params?: InvitationsControllerListPendingV1Params, options?: RequestInit): Promise<InvitationsControllerListPendingV1200> => {

  return apiRequest<InvitationsControllerListPendingV1200>(getInvitationsControllerListPendingV1Url(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getInvitationsControllerListPendingV1QueryKey = (params?: InvitationsControllerListPendingV1Params,) => {
    return [
    `/v1/invitations`, ...(params ? [params] : [])
    ] as const;
    }


export const getInvitationsControllerListPendingV1QueryOptions = <TData = Awaited<ReturnType<typeof invitationsControllerListPendingV1>>, TError = unknown>(params?: InvitationsControllerListPendingV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof invitationsControllerListPendingV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInvitationsControllerListPendingV1QueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof invitationsControllerListPendingV1>>> = ({ signal }) => invitationsControllerListPendingV1(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof invitationsControllerListPendingV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type InvitationsControllerListPendingV1QueryResult = NonNullable<Awaited<ReturnType<typeof invitationsControllerListPendingV1>>>
export type InvitationsControllerListPendingV1QueryError = unknown


export function useInvitationsControllerListPendingV1<TData = Awaited<ReturnType<typeof invitationsControllerListPendingV1>>, TError = unknown>(
 params: undefined |  InvitationsControllerListPendingV1Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof invitationsControllerListPendingV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof invitationsControllerListPendingV1>>,
          TError,
          Awaited<ReturnType<typeof invitationsControllerListPendingV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInvitationsControllerListPendingV1<TData = Awaited<ReturnType<typeof invitationsControllerListPendingV1>>, TError = unknown>(
 params?: InvitationsControllerListPendingV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof invitationsControllerListPendingV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof invitationsControllerListPendingV1>>,
          TError,
          Awaited<ReturnType<typeof invitationsControllerListPendingV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInvitationsControllerListPendingV1<TData = Awaited<ReturnType<typeof invitationsControllerListPendingV1>>, TError = unknown>(
 params?: InvitationsControllerListPendingV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof invitationsControllerListPendingV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List pending invitations, paginated/searchable/orderable (root user only)
 */

export function useInvitationsControllerListPendingV1<TData = Awaited<ReturnType<typeof invitationsControllerListPendingV1>>, TError = unknown>(
 params?: InvitationsControllerListPendingV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof invitationsControllerListPendingV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getInvitationsControllerListPendingV1QueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getInvitationsControllerCancelV1Url = (id: string,) => {




  return `/v1/invitations/${id}`
}

/**
 * @summary Cancel a pending invitation (root user only)
 */
export const invitationsControllerCancelV1 = async (id: string, options?: RequestInit): Promise<CancelInvitationResponseDto> => {

  return apiRequest<CancelInvitationResponseDto>(getInvitationsControllerCancelV1Url(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getInvitationsControllerCancelV1QueryKey = (id: string,) => {
    return [
    'DELETE', `/v1/invitations/${id}`
    ] as const;
    }


export const getInvitationsControllerCancelV1QueryOptions = <TData = Awaited<ReturnType<typeof invitationsControllerCancelV1>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof invitationsControllerCancelV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInvitationsControllerCancelV1QueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof invitationsControllerCancelV1>>> = ({ signal }) => invitationsControllerCancelV1(id, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof invitationsControllerCancelV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type InvitationsControllerCancelV1QueryResult = NonNullable<Awaited<ReturnType<typeof invitationsControllerCancelV1>>>
export type InvitationsControllerCancelV1QueryError = unknown


export function useInvitationsControllerCancelV1<TData = Awaited<ReturnType<typeof invitationsControllerCancelV1>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof invitationsControllerCancelV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof invitationsControllerCancelV1>>,
          TError,
          Awaited<ReturnType<typeof invitationsControllerCancelV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInvitationsControllerCancelV1<TData = Awaited<ReturnType<typeof invitationsControllerCancelV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof invitationsControllerCancelV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof invitationsControllerCancelV1>>,
          TError,
          Awaited<ReturnType<typeof invitationsControllerCancelV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInvitationsControllerCancelV1<TData = Awaited<ReturnType<typeof invitationsControllerCancelV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof invitationsControllerCancelV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Cancel a pending invitation (root user only)
 */

export function useInvitationsControllerCancelV1<TData = Awaited<ReturnType<typeof invitationsControllerCancelV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof invitationsControllerCancelV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getInvitationsControllerCancelV1QueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






